import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

import Nav from '../../globalComponents/nav/Nav';
import Auth from './appComponents/auth/Auth';
import Home from '../home/Home';
import Footer from '../../globalComponents/footer/Footer';
import Url from '../url'

function App() {
  const navigate = useNavigate()
  const [sessionToken, setSessionToken] = useState(null)
  const [user, setUser] = useState(null)
  const [userLoaded,setUserLoaded] = useState(false)
  const [admin, setAdmin]= useState(false)

  //on every load try to pull the stored token
  useEffect(() =>{
    if(localStorage.getItem("token")){
      setSessionToken(localStorage.getItem("token"))
    console.log(`local token found`)
    }
    },[])

    // function to set local storage token and set variables (token setsUserLoaded and user)
    const updateLocalStorage = (token,email,admin) => {
      
      localStorage.setItem("user",email)
      admin ? token = token.slice(0,3)+"Y"+token.slice(3) 
        : token = token.slice(0,3)+"N"+token.slice(3)
      setSessionToken(token)
      localStorage.setItem("token",token)
      
        setUser(user)
        setUserLoaded(true)
    }


    // first fetch user local storage token, to request the user object -> userObject into setUser
    useEffect(()=>{
      if (userLoaded){
      fetch (Url+'user/getUserInfo',{
          method:"GET",
          body: null,
          headers: new Headers({
              "Content-Type": "application/json",
              "authorization" : localStorage.getItem("token")
          })
      })
          .then(res=> res.json())
          .then(data=> {
              console.log(data.user)
              console.log(`fetched from /user/getUserInfo `+ localStorage.getItem("token"))
              //console.log(data.currentUser)
              setUser(data.currentUser)
              setUserLoaded(true)
              })
          .catch(err => {
              console.log(err)
          })}
    },[])
  
  return (
    
    <>
      <Nav></Nav>
      
      <h1>This is in App jsx</h1>
      
      {
      !sessionToken ? <Auth updateLocalStorage={updateLocalStorage}/>
        : userLoaded  ?  navigate("/"): null 
        }
        <div style={{marginTop:"280px"}}>

        </div>
        <Footer></Footer>
    </>
    
  )  
}

export default App
